import api from "./api";

const contingenciaService = {
  getAll: async (params = {}) => {
    const response = await api.get("/contingencia", { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/contingencia/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post("/contingencia", data);
    return response.data;
  },
};

export default contingenciaService;